export const ALLIE_DOMAIN = '.alliesystems.com';

export interface TenantCompany {
  subdomain: string;
  name: string;
}

export interface MatchCompanyParams {
  companyName?: string;
  subdomain?: string;
  isTest?: boolean;
}

export const getCurrentSubdomain = (
  domain: string = ALLIE_DOMAIN
): string => {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location.hostname.replace(domain, '');
};

export const isCompany = (
  companies: readonly TenantCompany[],
  {
    companyName,
    subdomain,
    isTest = false,
  }: MatchCompanyParams
): boolean => {
  if (isTest) {
    return true;
  }

  const resolvedSubdomain = subdomain ?? getCurrentSubdomain();
  const normalize = (value: string): string => value.trim().toLowerCase();
  const normalizedName = companyName != null ? normalize(companyName) : undefined;

  return companies.some(
    (company) =>
      (normalizedName != null && normalize(company.name) === normalizedName)
      || company.subdomain === resolvedSubdomain
  );
};

export const createCompanyMatcher = (
  companies: readonly TenantCompany[]
) => (params: MatchCompanyParams): boolean => isCompany(companies, params);
